import { StaticBookingContent } from '@/api/MyBookingStaticContent/myBookingStaticContent.interfaces';

export const fakeMyBookingStaticContent: StaticBookingContent = {
    SpecialNeedsOptions: [
        {
            Name: 'Inget specialbehov',
            Value: 0,
        },
        {
            Name: 'Hörselskadad',
            Value: 1,
        },
        {
            Name: 'Synskadad',
            Value: 2,
        },
        {
            Name: 'Synskadad/hörselskadad',
            Value: 3,
        },
        {
            Name: 'Rullstolsburen',
            Value: 4,
        },
        {
            Name: 'Elektrisk rullstol',
            Value: 5,
        },
        {
            Name: 'Rollator',
            Value: 6,
        },
        {
            Name: 'Medicinering',
            Value: 8,
        },
        {
            Name: 'Behöver assistans',
            Value: 10,
        },
    ],
};
